<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qvSA60/tc-custom/9798889107408.jpg?1716663068585" alt="This image is the cover for the book The Truth Is in the Words"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Truth Is in the Words
      </h1>
      <p class="bookDescription body article font2">
        <p>The Truth Is in the Words<span style='font-size:16px;font-family:"Times New Roman",serif;'> holds within its pages two novellas, Noula's Prayer &amp; The House That Called Me Home. The House that Called Me Home begins with a dream, a haunting dream that comes true in steps to reveal the power of prayer, the patience of love and the healing from life controlling shame. It's a story that touches your heart and maybe even your own story.  It shows you that you're never too old to find out that you have been loved all along. That is what Celine finds out when her dreams come to an end in reality.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>Noula's Prayer takes you on a journey through many lives which all end up in the same church. When God asks Noula for one prayer and one prayer only, she searches her heart and examines her life, she then seeks guidance in God's Word. Noula finally prays her one prayer. Will God answer..?</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ginette Therrien
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;'>Ginette is a French-Canadian woman who lives in a small coastal town in Cape Breton, Nova Scotia, with her cock-a-poo, Bijou. This is Ginette&rsquo;s third book, in which she shares her passion for words that can easily touch your heart. She believes that words come easily from the heart when you live so close to paradise.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0cd30cdd